import { render, staticRenderFns } from "./serial-list.vue?vue&type=template&id=92ca9912&scoped=true"
import script from "./serial-list.vue?vue&type=script&lang=js"
export * from "./serial-list.vue?vue&type=script&lang=js"
import style0 from "./serial-list.vue?vue&type=style&index=0&id=92ca9912&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ca9912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92ca9912')) {
      api.createRecord('92ca9912', component.options)
    } else {
      api.reload('92ca9912', component.options)
    }
    module.hot.accept("./serial-list.vue?vue&type=template&id=92ca9912&scoped=true", function () {
      api.rerender('92ca9912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/serial-management/serial-list.vue"
export default component.exports